export type ExpandedDayHeaderControl = 'back' | 'previous' | 'next';

export const EXPANDED_DAY_HEADER_ROW_HEIGHT = 24;
export const EXPANDED_DAY_NAV_OFFSET = 80;
export const EXPANDED_DAY_NAV_HIT_WIDTH = 48;
export const EXPANDED_DAY_NAV_BUTTON_WIDTH = 36;
export const EXPANDED_DAY_NAV_BUTTON_HEIGHT = 20;
export const EXPANDED_DAY_BACK_HIT_WIDTH = 88;

/**
 * Resolve the interactive control under a pointer in expanded-day mode.
 * Navigation hit areas are centred on the rendered glyphs and deliberately
 * larger than the visible button so small pointer movement does not miss.
 */
export function getExpandedDayHeaderControl(
  x: number,
  y: number,
  canvasWidth: number,
): ExpandedDayHeaderControl | null {
  if (y < 0 || y > EXPANDED_DAY_HEADER_ROW_HEIGHT || x < 0 || x > canvasWidth) {
    return null;
  }

  if (x <= EXPANDED_DAY_BACK_HIT_WIDTH) {
    return 'back';
  }

  const centerX = canvasWidth / 2;
  const halfHitWidth = EXPANDED_DAY_NAV_HIT_WIDTH / 2;
  const previousCenter = centerX - EXPANDED_DAY_NAV_OFFSET;
  const nextCenter = centerX + EXPANDED_DAY_NAV_OFFSET;

  if (Math.abs(x - previousCenter) <= halfHitWidth) {
    return 'previous';
  }
  if (Math.abs(x - nextCenter) <= halfHitWidth) {
    return 'next';
  }
  return null;
}
